import React from "react";
import PageNotFoundChild from "./PageNotFoundChild";

const PageNotFound = () => {
  return <PageNotFoundChild />;
};

export default PageNotFound;
